module.exports = __webpack_public_path__ + "e085e22ff058f13e9c0cb8bb39d80728.png";